<template>
  <div id="calendar">
    <Fullcalendar
      v-if="showCalendar"
      id="calendar"
      :plugins="calendarPlugins"
      :header="{
         left:'title',
         center:'dayGridMonth,timeGridWeek,timeGridDay,listWeek',
         right:'prev today next'
     }"
      :buttonText="{
         today : 'Aujourd\'hui',
         month: 'Mois',
         week:'Semaine',
         day:'Jour',
         list :'Liste'
     }"
      :events="calendarEvents"
      :selectable="true"
      @dateClick="handleDateClick"
      @eventRender="eventRender"
      @eventClick="updateEvent"
      :editable="true"
    />
    <div class="Model" v-if="showmodal">
      <form @submit="submitEvent()">
        <strong>Title:</strong>
        <input type="text" class="form-control" v-model="Title" required />
        <strong>Start:</strong>
        <input type="datetime-local" class="form-control" v-model="Start" />
        <strong>End:</strong>
        <input type="datetime-local" class="form-control" v-model="End" />
        <strong>Description:</strong>
        <textarea class="form-control" v-model="Description" required></textarea>

        <button class="btn_btn">Valider</button>
        <button class="btn_btn" @click="cancel()">Annuler</button>
      </form>
    </div>

    <div class="Model" v-if="putmodal">
      <div>
        <strong>Title:</strong>
        <input type="text" class="form-control" v-model="evput.title" />
        <strong>Start:</strong>
        <input type="datetime-local" class="form-control" v-model="evput.start" />
        <strong>End:</strong>
        <input type="datetime-local" class="form-control" v-model="evput.end" />
        <strong>Description:</strong>
        <textarea class="form-control" v-model="evput.description"></textarea>
        <button class="btn_btn" @click="updateEventSubmit(evput)">Confirmer</button>
        <button class="btn_btn" @click="cancelput()">Annuler</button>
      </div>
    </div>
    <b-alert
      :show="isNotificationOpen"
      variant="success"
      :class="{ alertTransform: true, alertAfter: alertAfter }"
      dismissible
    >Bienvenu Dans Votre Calendrier</b-alert>
    <div class="Model_Remove" v-if="removeQuestion">
      <p class="QuestionRemove">Voulez-vous Supprimer Cette Evenement ?</p>
      <br />
      <button class="btn_btn_Remove" @click="sureRemove(key)">Oui</button>
      <button class="btn_btn_Remove" @click="cancelRemove()">Annuler</button>
    </div>
  </div>
</template>

<script>
require("@fullcalendar/daygrid/main.min.css");
require("@fullcalendar/timegrid/main.min.css");
require("@fullcalendar/core/main.min.css");

import Fullcalendar from "@fullcalendar/vue";
import DayGridPlugin from "@fullcalendar/daygrid";
import TimeGridPlugin from "@fullcalendar/timegrid";
import InteractionPlugin from "@fullcalendar/interaction";
import ListPlugin from "@fullcalendar/list";
import axios from "axios";
import Vue from "vue";

export default {
  data() {
    return {
      calendarPlugins: [
        DayGridPlugin,
        TimeGridPlugin,
        InteractionPlugin,
        ListPlugin
      ],
      showCalendar: false,
      showmodal: false,
      putmodal: false,
      evput: null,
      alertAfter: false,
      isNotificationOpen: true,
      removeQuestion: false,

      Title: "",
      Start: "",
      End: "",
      Description: "",
      key: null,

      calendarEvents: []
    };
  },
  created() {
    this.get();
    setTimeout(() => {
      this.fixAlert();
    }, 500);
  },

  methods: {
    sureRemove(keyy) {
      var self = this;
      axios
        .delete("http://localhost:52865/api/values/" + keyy)
        .then(function() {
          self.cancelput();
          self.cancelRemove();
          self.get();
        });
    },

    showremovemodal() {
      this.removeQuestion = true;
      this.showmodal = false;
    },
    cancelRemove() {
      this.removeQuestion = false;
    },

    closeNotification() {
      Vue.set(this, "isNotificationOpen", false);
    },
    fixAlert() {
      Vue.set(this, "alertAfter", true);
    },
    get() {
      var self = this;
      self.showCalendar = false;
      // self.calendarEvents=[];
      axios
        .get("http://localhost:52865/api/values/")
        .then(function(res) {
          self.calendarEvents = Object.assign([], res.data);
          self.cancelput();
          self.showCalendar = true;
        })
        .catch(function(error) {
          window.console.log("Error: ", error);
        });
    },
    cancel() {
      this.showmodal = false;
    },
    cancelput() {
      this.putmodal = false;
    },
    submitEvent() {
      var self = this;
      axios
        .post("http://localhost:52865/api/values/", {
          Title: this.Title,
          Start: this.Start,
          End: this.End,
          Description: this.Description
        })
        .then(function(res) {
          self.cancelRemove();
          window.console.log("resss", res);
        });
    },
    handleDateClick() {
      this.showmodal = true;
      this.removeQuestion = false;
    },
    updateEvent(eventObject) {
      this.putmodal = true;
      this.evput = Object.assign(
        {},
        this.calendarEvents.find(acc => acc.id == eventObject.event.id)
      );
      window.console.log("eventput-eventput", event);
    },
    updateEventSubmit(eventtoupdate) {
      var self = this;
      var idput = eventtoupdate.id;
      axios
        .put("http://localhost:52865/api/values/" + idput, {
          Id: idput,
          Title: eventtoupdate.title,
          Start: eventtoupdate.start,
          End: eventtoupdate.end,
          Description: eventtoupdate.description
        })
        .then(function(res) {
          self.cancelput();
          window.console.log("resultat", res);
          self.get();
        });
    },

    eventRender(calendarEvents) {
      var self = this;
      var btn = document.createElement("button");
      btn.appendChild(document.createTextNode("x"));
      btn.addEventListener("click", () => {
        self.key = calendarEvents.event.id;
        self.showremovemodal();
      });
      calendarEvents.el.appendChild(btn);
    }
  },
  name: "Calendar",
  components: {
    Fullcalendar
  },
  props: {
    msg: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.QuestionRemove {
  margin-top: 5%;
}
.Model {
  background-color: #dedede;
  position: fixed;
  width: 43%;
  margin-left: 30%;
  z-index: 9;
  border-radius: 20px;
}
.Model_Remove {
  background-color: #dedede;
  position: fixed;
  width: 43%;
  margin-left: 30%;
  z-index: 9;
  border-radius: 20px;
  height: 23%;
}

.form-control {
  width: 60%;
  margin-left: 20%;
}
#calendar {
  position: absolute;
  width: 100%;
  height: 100%;
}

.btn_btn {
  background-color: #ffc24d;
  margin-top: 2%;
  margin: 2%;
  margin-bottom: 2%;
  width: 28%;
  border: none;
  border-radius: 20px;
}
.btn_btn_Remove {
  background-color: #ffc24d;
  margin-top: 2%;
  margin: 2%;
  margin-top: 2%;
  width: 28%;
  border: none;
  border-radius: 20px;
}

.alertTransform {
  transition: 0.6s;
  transition-timing-function: ease;
  transform: translateX(-130vw);
  padding-right: 1.25rem;
  margin-left: 60%;
  margin-top: -4%;
}
.alertAfter {
  transform: translateX(0);
}
</style>
